
import { createAction } from '@reduxjs/toolkit';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const logoutRequestAction = createAction(LOGOUT_REQUEST);